<template>
    <div>
        <div class="headingWizard">
            Cancel Appointment
        </div>
        <div class="widthContainer">
            <div class="pageLayout">
                <div class="formConatiner">
                    <div>
                        <h3>{{cancelappointment.thankmsg}}</h3>
                        <p>
                            {{cancelappointment.cancelmsg}}
                        </p>

                    </div>
                    <div class="infoTable">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        <div class="lableText"> Appointment Date </div>
                                        <div class="detailsText">
                                            {{appointmentDateString}}
                                        </div>
                                    </th>
                                    <th>
                                        <div class="lableText">
                                            Appointment Time
                                        </div>
                                        <div class="detailsText">
                                            {{formatTime12(appointmentDetails.startTime)}}
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colspan="2">
                                        <div class="lableText">
                                            Name
                                        </div>
                                        <div class="detailsText">
                                            {{appointmentDetails.name}}
                                        </div>
                                    </td>

                                </tr>
                                <tr>
                                    <td>
                                        <div class="lableText">
                                            Mobile Number
                                        </div>
                                        <div class="detailsText">
                                            <span v-if="appointmentDetails.phoneNumber">
                                                {{appointmentDetails.phoneNumber}}
                                            </span>
                                            <span v-else>
                                                -
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="lableText">
                                            Email Address
                                        </div>
                                        <div class="detailsText">
                                            <span v-if="appointmentDetails.email">
                                                {{appointmentDetails.email}}
                                            </span>
                                            <span v-else>
                                                -
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td>
                                        <div class="lableText">
                                            Service Name
                                        </div>
                                        <div class="detailsText">
                                            {{appointmentDetails.serviceName}}
                                        </div>
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="p-0">
                                        <div class="appInfoDetails" v-if="isVehicalShow">
                                            <div class="lableText">
                                                Vehicle Number
                                            </div>
                                            <div class="detailsText">
                                                {{capitalize(appointmentDetails.vehicleNumber)}}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="isNoticeShow">
                                            <div class="lableText">
                                                Notice Number
                                            </div>
                                            <div class="detailsText">
                                                {{capitalize(appointmentDetails.noticeNumber) }}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="isVacShow">
                                            <div class="lableText">
                                                VAC Number
                                            </div>
                                            <div class="detailsText">
                                                {{capitalize(appointmentDetails.vacNumber) }}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="isPARFShow">
                                            <div class="lableText">
                                                PARF Number
                                            </div>
                                            <div class="detailsText">
                                                {{capitalize(appointmentDetails.parfNumber)}}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="isCEORShow">
                                            <div class="lableText">
                                                COE Number
                                            </div>
                                            <div class="detailsText">
                                                {{capitalize(appointmentDetails.coeNumber) }}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="isTcoeShow">
                                            <div class="lableText">
                                                TCOE Number
                                            </div>
                                            <div class="detailsText">
                                                {{capitalize(appointmentDetails.tcoeNumber)}}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="ishVParkShow">
                                            <div class="lableText">
                                                HV Park Number
                                            </div>
                                            <div class="detailsText">
                                                {{capitalize(appointmentDetails.hvParkNumber)}}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="isDeviceNumberShow">
                                            <div class="lableText">
                                                Device Number
                                            </div>
                                            <div class="detailsText">
                                                {{capitalize(appointmentDetails.deviceNumber)}}
                                            </div>
                                        </div>

                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <div>
                                            <div class="lableText">
                                                Notes to LTA
                                            </div>
                                            <div class="detailsText" v-html="appointmentDetails.remarks">
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <div>
                                            <div class="lableText">
                                                Reason for Cancellation
                                            </div>
                                            <div class="detailsText">
                                                {{appointmentDetails.cancelledRemark}}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td>
                                        <div class="lableText">
                                            Appointment Reference ID
                                        </div>
                                        <div class="detailsText" v-html="appointmentDetails.referenceNumber">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="lableText">
                                            Transaction Date & Time
                                        </div>
                                        <div class="detailsText">
                                            {{appointmentTrasactDateTime}}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <p class="mt-4">
                        {{cancelappointment.clickmsg}}
                    </p>

                    <div class="buttonContainer paddingBottom marginTop">
                        <div class="p-col-12">
                            <div class="float-left">
                                <Button label="< Home" @click="onBackclick" class="linkBtn" />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .marginTop {
        margin-top: 15px;
    }

    .Textareahight {
        min-height: 90px;
    }
</style>
<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

const store = useStore()
const router = useRouter()

const id = ref(null)
const appointmentTrasactDateTime = ref('')
const appointmentDateString = ref('')

const isVehicalShow = ref(false)
const isNoticeShow = ref(false)
const isVacShow = ref(false)
const isPARFShow = ref(false)
const isCEORShow = ref(false)
const isTcoeShow = ref(false)
const ishVParkShow = ref(false)
const isDeviceNumberShow = ref(false)

const appointmentDetails = ref({
  remarks: '',
  postBookingMessage: '',
  vehicleNumber: '',
  noticeNumber: '',
  vacNumber: '',
  deviceNumber: '',
  parfNumber: '',
  coeNumber: '',
  tcoeNumber: '',
  hvParkNumber: '',
  serviceName: '',
  name: '',
  phoneNumber: '',
  email: '',
  appointmentDateTime: '',
  tag: '',
  referenceNumber: '',
  generateDateTime: '',
  appointmentDate: '',
  startTime: '',
  endTime: '',
  noteToLta: ''
})
function formatTime12(value) {
    if (value) {
        const [hoursStr, minutesStr] = value.split(':');
        let hours = parseInt(hoursStr, 10);
        const minutes = parseInt(minutesStr, 10);
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // convert 0 to 12 for 12-hour format

        return `${hours}:${String(minutes).padStart(2, '0')} ${ampm}`;
    }
    return value;
}
const cancelappointment = ref({
  thankmsg: 'Thank you!',
  cancelmsg: 'You have successfully cancelled your appointment.',
  clickmsg: 'Click Home for other appointment related services.'
})

function onBackclick() {
  store.dispatch('reset').then(() => {
    router.push({ path: '/' })
  })
}
function capitalize(value) {
    if (!value) return "";
    value = value.toString();
    return value.toUpperCase();
}
function getData() {
  appointmentDetails.value = store.getters.getAppointmentAcknowlegement
  appointmentDateString.value = store.getters.getAppointmentDateString
  appointmentTrasactDateTime.value = store.getters.getTransactionDateString
}

onMounted(() => {
  getData()
})

// computed equivalents
const onVehicalNumberChange = computed(() => appointmentDetails.value.vehicleNumber)
const onNoticeNumberChange = computed(() => appointmentDetails.value.noticeNumber)
const onVACNumberChange = computed(() => appointmentDetails.value.vacNumber)
const onPARFNumberChange = computed(() => appointmentDetails.value.parfNumber)
const onCOENumberChange = computed(() => appointmentDetails.value.coeNumber)
const onTCOENumberChange = computed(() => appointmentDetails.value.tcoeNumber)
const onHVParkNumberChange = computed(() => appointmentDetails.value.hvParkNumber)
const onDeviceNumberChange = computed(() => appointmentDetails.value.deviceNumber)

// watchers
watch(onVehicalNumberChange, val => { if (val) isVehicalShow.value = true })
watch(onNoticeNumberChange, val => { if (val) isNoticeShow.value = true })
watch(onVACNumberChange, val => { if (val) isVacShow.value = true })
watch(onPARFNumberChange, val => { if (val) isPARFShow.value = true })
watch(onCOENumberChange, val => { if (val) isCEORShow.value = true })
watch(onTCOENumberChange, val => { if (val) isTcoeShow.value = true })
watch(onHVParkNumberChange, val => { if (val) ishVParkShow.value = true })
watch(onDeviceNumberChange, val => { if (val) isDeviceNumberShow.value = true })
</script>
